import { Component } from '@angular/core';

@Component({
  selector: 'cms-show-more',
  templateUrl: './cms-show-more.component.html',
})
export class CmsShowMoreComponent {}
